import { CheckIcon, InfoIcon, TriangleAlertIcon } from 'lucide-react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

/** Night toasts, bottom left, 6 s, undo via `action`. */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-left"
      gap={8}
      duration={6000}
      visibleToasts={4}
      closeButton
      icons={{
        success: <CheckIcon className="size-3.5" />,
        error: <TriangleAlertIcon className="size-3.5 text-[#f5b971]" />,
        warning: <TriangleAlertIcon className="size-3.5 text-[#f5b971]" />,
        info: <InfoIcon className="size-3.5" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'group relative flex w-[400px] max-w-[calc(100vw-32px)] items-center gap-3 rounded-md bg-night py-2 pr-11 pl-4 text-note text-white shadow-menu min-h-11',
          title: 'leading-5',
          description: 'text-meta text-white/75',
          content: 'flex min-w-0 flex-1 flex-col gap-0.5 py-1',
          icon: 'flex size-3.5 shrink-0 items-center justify-center text-steel',
          actionButton:
            'h-7 shrink-0 rounded-xs border border-white/40 bg-transparent px-2.5 text-meta leading-none font-medium text-white hover:border-white/70 hover:bg-white/10',
          cancelButton:
            'h-7 shrink-0 rounded-xs border border-transparent bg-transparent px-2.5 text-meta font-medium text-white/80 hover:text-white',
          closeButton:
            'absolute! top-1/2! right-2! left-auto! flex! size-7! -translate-y-1/2! transform-none! items-center justify-center border-0! bg-transparent! text-white/80! hover:bg-white/10! hover:text-white! [&_svg]:size-3.5',
        },
      }}
      {...props}
    />
  )
}
